import Form from '@utilities/form';
import signinConstraints from './signin-constraints';

const JS_HOOK_SIGNIN_ALERT = '[js-hook-signin-alert]';

/**
 * Used to handle signin requests from user
 *
 * @class SigninForm
 * @extends {Form}
 */
class SigninForm extends Form {
  constructor(element) {
    super(element);

    this.messageSelector = JS_HOOK_SIGNIN_ALERT;

    // Init constraints
    this.initConstraints();

    // Events: Submit & Change Events
    this.bindChangeEvents();
    this.bindSubmitEvents();
  }

  // eslint-disable-next-line class-methods-use-this
  afterSubmitFormSuccess(data) {
    if (data.email && window._etmc) {
      window._etmc.push(['setUserInfo', { email: data.email }]);
    }
  }

  /**
   * Init constraints for form validation for validate.js
   */
  initConstraints() {
    this.constraints = signinConstraints(this.customValidationMessages);
  }
}

export default SigninForm;
